export default {
  'examinator_type': [
    {
      'name': '母亲',
      'id': 'bec947eb-21de-4d11-b08e-06823cd06c3a',
      'code': 'mom'
    }, {
      'name': '父亲',
      'id': '0890f7b5-231f-44ef-bbc5-449aa4ea2dce',
      'code': 'dad'
    }, {
      'name': '岳父',
      'id': '3e8215ec-319d-41df-ac39-90273b08337f',
      'code': 'father_in_law'
    }, {
      'name': '岳母',
      'id': '3d67f5ca-3822-4298-bb9f-43fa85d6f2b3',
      'code': 'mother_in_law'
    }, {
      'name': '姐姐',
      'id': '9d854133-aceb-4b38-a807-e8e07b10ec89',
      'code': 'old_sister'
    }, {
      'name': '妹妹',
      'id': '4f68a2c5-1b84-4018-ab58-fbcd147df2bc',
      'code': 'younger_sister'
    }, {
      'name': '妻子',
      'id': 'f0164beb-9ea6-4cef-a120-0df1affe79aa',
      'code': 'wife'
    }, {
      'name': '丈夫',
      'id': 'd9f89a82-493e-474d-82f7-62214d831c83',
      'code': 'husband'
    }, {
      'name': '儿子',
      'id': '247f804e-4e56-4ebd-9d30-3a0a785c7323',
      'code': 'son'
    }, {
      'name': '女儿',
      'id': '56e11e4d-a1c9-403f-a75a-242f69e09cb3',
      'code': 'daughter'
    }, {
      'name': '哥哥',
      'id': 'b4ff7fd3-8ed8-48c9-812c-c7a51ea4a12b',
      'code': 'brother'
    }, {
      'name': '弟弟',
      'id': '4244cbdc-982a-4abf-bc1a-cee00bb4c36d',
      'code': 'little_brother'
    }, {
      'name': '外婆',
      'id': '60ae358b-8bf5-43b9-af19-9d204c34404f',
      'code': 'grandmother_1'
    }, {
      'name': '外公',
      'id': 'b8568077-ed04-46a8-8d52-3f1b55684610',
      'code': 'grandfather_1'
    }, {
      'name': '奶奶',
      'id': 'ae99d681-0223-426d-b61a-abf678e71385',
      'code': 'grandmother'
    }, {
      'name': '爷爷',
      'id': '96d28aa7-e3f5-48f0-8ef8-04e869b8c50e',
      'code': 'grandfather'
    }, {
      'name': '其他',
      'id': 'dd48bb60-b424-4faa-bff5-e7662b9d35e0',
      'code': 'other'
    }],
  'sex_type': [
    {
      'code': 'male',
      'name': '男',
      'id': '8fd57248-d651-4b5c-b0e0-3052c14d186c',
      'value': null
    },
    {
      'code': 'female',
      'name': '女',
      'id': '3b440ff4-e2df-4bcc-b6ac-5773e88f72be',
      'value': null
    }
  ],
  'user_profession': [
    {
      'code': 'wu',
      'name': '无',
      'id': '3DD76DECCFE241EE8C7B688C6EBDA766',
      'value': null
    },
    {
      'code': 'gwy',
      'name': '国家公务员',
      'id': '31621BB0EA1843018721ED4AC4962FD4',
      'value': null
    },
    {
      'code': 'js',
      'name': '专业技术人员',
      'id': '441E10D8BCF84B77B846358F90C9E34C',
      'value': null
    },
    {
      'code': 'zy',
      'name': '职员',
      'id': 'EC4591B783B2463CB8EBAF0441BD0186',
      'value': null
    },
    {
      'code': 'qygl',
      'name': '企业管理人员',
      'id': '4556FFE41D954862B49CDD3EF4BF4DB8',
      'value': null
    },
    {
      'code': 'gr',
      'name': '工人',
      'id': 'C325DBDCEE104E1ABF16627310A7C25E',
      'value': null
    },
    {
      'code': 'nm',
      'name': '农民',
      'id': '8E7699A03DD24EF2A8E182B5588959FD',
      'value': null
    },
    {
      'code': 'xs',
      'name': '学生',
      'id': '67A4A79E2FFE498DB129966A1C74D4A3',
      'value': null
    },
    {
      'code': 'jr',
      'name': '现役军人',
      'id': 'E15BC642E6A44AC68BF30B3F4B1A2577',
      'value': null
    },
    {
      'code': 'zyzy',
      'name': '自由职业者',
      'id': '2E095D30A7F5469C94BA36B1C83E24BD',
      'value': null
    },
    {
      'code': 'gt',
      'name': '个体经营者',
      'id': '06619486E0BB43DCBB39762B49D7ED79',
      'value': null
    },
    {
      'code': 'wy',
      'name': '无业人员',
      'id': 'E46B7910BE2E4A86A048B1C8D887008E',
      'value': null
    },
    {
      'code': 'tx',
      'name': '退（离）休人员',
      'id': '0CC9C385767E4B7A9F2188A3C72953C7',
      'value': null
    },
    {
      'code': 'qt',
      'name': '其他',
      'id': '6F4E688D324C48128ECA976EFB9F1217',
      'value': null
    }
  ],
  'payment_type': [
    {
      'code': 'onhospital',
      'name': '医院支付',
      'id': 'a2f1f353-309e-41ed-9adf-7af02ab4a032',
      'value': '(预约后到体检中心支付)'
    },
    {
      'code': 'online',
      'name': '在线支付',
      'id': '67621b22-9b44-4a4c-90f7-9fa9f23755a2',
      'value': ''
    }
  ],
  'check_type': [
    {
      'code': 'cream',
      'name': '青年体检',
      'id': '9bff0590-5ab2-4af1-b3e5-cefeda8d9111',
      'value': 'test-elite'
    },
    {
      'code': 'pet_ct',
      'name': '中年体检',
      'id': 'a47dd0f7-bb2c-4ae9-a05f-15b671344f9e',
      'value': 'test-PET'
    },
    {
      'code': 'older',
      'name': '老年体检',
      'id': 'd13d1c19-fc20-4be0-875b-a41968ed2d3b',
      'value': 'test-old'
    },
    {
      'code': 'general',
      'name': '常规检查',
      'id': '16b68a97-eccd-44e7-929c-ab502f24c757',
      'value': 'test-general'
    },
    {
      'code': 'newEmployee',
      'name': '入职体检',
      'id': '79e32fd7-1f17-4669-9f05-b5874a11c756',
      'value': 'test-company'
    },
    {
      'code': 'gravida',
      'name': '孕前检查',
      'id': '1d19e32e-3737-4e64-8b39-65f336b8d9d7',
      'value': 'test-gravida'
    },
    {
      'code': 'chronic',
      'name': '慢病检测',
      'id': '0114a438-34ed-4c44-9a8d-eadb6ad263ca',
      'value': 'test-NCD'
    },
    {
      'code': 'children',
      'name': '功能医学',
      'id': '2b52b862-bab9-4eed-94fd-e534f0d6fcb1',
      'value': 'test-child'
    }, {
      'code': 'women',
      'name': '女性专区',
      'value': 'test-women',
      'id': 'd13d1c19-fc20-4be0-875b-a41968ed2d3r'
    }
  ],
  'user_folk': [
    {
      'code': '0',
      'name': '汉族',
      'id': '4A59E4C1AB4044C6836556ADE4E6B65B',
      'value': null
    },
    {
      'code': '1',
      'name': '阿昌族',
      'id': '961EE3842397479CADCE0EE2267E3364',
      'value': null
    },
    {
      'code': '2',
      'name': '白族',
      'id': 'CE997276C43945E19954F58EEE58C8A0',
      'value': null
    },
    {
      'code': '3',
      'name': '保安族',
      'id': '0218843D56314AD995A912994E42AAB7',
      'value': null
    },
    {
      'code': '4',
      'name': '布朗族',
      'id': 'AC747B91D0A743E7831DA9587195F4A7',
      'value': null
    },
    {
      'code': '5',
      'name': '布依族',
      'id': '5459A57843394383B45A51BCB17F14AB',
      'value': null
    },
    {
      'code': '6',
      'name': '藏族',
      'id': 'D770A186B00B48649551EEB49E5BDB4D',
      'value': null
    },
    {
      'code': '7',
      'name': '朝鲜族',
      'id': '991694DD4B99430F97634A6042EA9700',
      'value': null
    },
    {
      'code': '8',
      'name': '达斡尔族',
      'id': '442D7EB0DA84487FAEC1F4CCAF07D02B',
      'value': null
    },
    {
      'code': '9',
      'name': '傣族',
      'id': 'C9E2ADFD1DC7492AB2D4F3AB988BFF4D',
      'value': null
    },
    {
      'code': '10',
      'name': '德昂族',
      'id': 'AFC79238CF0B4EF1A53A05CD22A8A4E7',
      'value': null
    },
    {
      'code': '11',
      'name': '东乡族',
      'id': '35FC2D2DFE8F4045B299613A912A61A0',
      'value': null
    },
    {
      'code': '12',
      'name': '侗族',
      'id': '64A2774E31F940508D92D6ED07792285',
      'value': null
    },
    {
      'code': '13',
      'name': '独龙族',
      'id': '2A2B7A83303241DD81438694B3761FB8',
      'value': null
    },
    {
      'code': '14',
      'name': '俄罗斯族',
      'id': 'BBE272CAFBC448FDB045C4FDB47E324A',
      'value': null
    },
    {
      'code': '15',
      'name': '鄂伦春族',
      'id': '6E9671BA643A446A9FABEE1A574E8FF7',
      'value': null
    },
    {
      'code': '16',
      'name': '鄂温克族',
      'id': '6EF766CFBC8C4A71B32DEC4DB04D83B1',
      'value': null
    },
    {
      'code': '17',
      'name': '高山族',
      'id': '1E8FA64E37DE4CE6AE11815551ACB568',
      'value': null
    },
    {
      'code': '18',
      'name': '哈尼族',
      'id': '6F3BD236F2614F3BB785FB7938BB6F6F',
      'value': null
    },
    {
      'code': '19',
      'name': '哈萨克族',
      'id': '89073EFD6C07438791CBFF5FF480D43A',
      'value': null
    },
    {
      'code': '21',
      'name': '赫哲族',
      'id': '88BA467CDF9A4E149028C6B847B64D66',
      'value': null
    },
    {
      'code': '22',
      'name': '回族',
      'id': '8C0874C1CC4D487F80281BBC26A42FBE',
      'value': null
    },
    {
      'code': '23',
      'name': '基诺族',
      'id': 'B677A665A6204650ACA4CF6A340CB4A3',
      'value': null
    },
    {
      'code': '24',
      'name': '京族',
      'id': 'C1110AB3B57C40EABE3D26D9CD7BF5EE',
      'value': null
    },
    {
      'code': '25',
      'name': '景颇族',
      'id': 'CA266D13EF6A48D18AEA0F10B202C2CA',
      'value': null
    },
    {
      'code': '26',
      'name': '柯尔克孜族',
      'id': '646B1B98C34B40E5813D588833946836',
      'value': null
    },
    {
      'code': '27',
      'name': '拉祜族',
      'id': '38D263F648F64531A4E117DBA73E2BBF',
      'value': null
    },
    {
      'code': '28',
      'name': '黎族',
      'id': '7B10B3CA9BB44C3A9899D4B55BC8751D',
      'value': null
    },
    {
      'code': '29',
      'name': '珞巴族',
      'id': 'F148BF75C38F442C9AF156869CF2E880',
      'value': null
    },
    {
      'code': '30',
      'name': '满族',
      'id': 'FE7E8B5D3F9940F2AD1B5C06D388CF3D',
      'value': null
    },
    {
      'code': '31',
      'name': '毛南族',
      'id': '60F6F69090EF45A6B68086064AD193DA',
      'value': null
    },
    {
      'code': '32',
      'name': '门巴族',
      'id': 'A12FF2586E274689807484E1480A191A',
      'value': null
    },
    {
      'code': '33',
      'name': '蒙古族',
      'id': 'E405D3993DB749C5981E56F5967F6EE8',
      'value': null
    },
    {
      'code': '34',
      'name': '苗族',
      'id': '83AED7EE6D934710ACD7B58D0060D577',
      'value': null
    },
    {
      'code': '35',
      'name': '仫佬族',
      'id': '3C19530600C242A38445F37698B75996',
      'value': null
    },
    {
      'code': '36',
      'name': '纳西族',
      'id': 'CD87ACE5ADA1408C940F585CCB2DE248',
      'value': null
    },
    {
      'code': '37',
      'name': '怒族',
      'id': '29FA9F5D824441BCB32CB6B5D5F6F926',
      'value': null
    },
    {
      'code': '38',
      'name': '普米族',
      'id': 'BFB2EA16382C41D2B0FBD8C1BBF38404',
      'value': null
    },
    {
      'code': '39',
      'name': '羌族',
      'id': '4F3089E6D40D4BBA8761B964C127A6BF',
      'value': null
    },
    {
      'code': '40',
      'name': '撒拉族',
      'id': 'D289746990884406B2B216E670602C27',
      'value': null
    },
    {
      'code': '41',
      'name': '畲族',
      'id': '7FEB3E971922425C9A364C18A680A1D3',
      'value': null
    },
    {
      'code': '42',
      'name': '水族',
      'id': '3F3F8DA992D4481B96396614588BEF15',
      'value': null
    },
    {
      'code': '43',
      'name': '僳僳族',
      'id': '257F6FD0F33A40EEBC21019CBBB7932B',
      'value': null
    },
    {
      'code': '44',
      'name': '塔吉克族',
      'id': 'A03FA73E47DA40C48FC311F5A98D4BE2',
      'value': null
    },
    {
      'code': '45',
      'name': '塔塔尔族',
      'id': '0AA4842549694C05AB324B6D530EF340',
      'value': null
    },
    {
      'code': '46',
      'name': '土家族',
      'id': 'E3E9FFDB44744D71996DC0C0F8B42C0E',
      'value': null
    },
    {
      'code': '47',
      'name': '土族',
      'id': '1EF2E4547E724A87B2367FD60B322351',
      'value': null
    },
    {
      'code': '48',
      'name': '佤族',
      'id': '5F86E38917944652B84F2681E26C2684',
      'value': null
    },
    {
      'code': '49',
      'name': '维吾尔族',
      'id': '3C7FC925AEAE40429EAC607CDF74AD6F',
      'value': null
    },
    {
      'code': '50',
      'name': '乌孜别克族',
      'id': 'ED4D9AF0FBA84A1B9D6BA6C97B6F0A89',
      'value': null
    },
    {
      'code': '51',
      'name': '锡伯族',
      'id': '25095E41BCA14CDFA0C8924286482649',
      'value': null
    },
    {
      'code': '52',
      'name': '瑶族',
      'id': 'F7B0F5A3134B4B57A7939931B7005650',
      'value': null
    },
    {
      'code': '53',
      'name': '彝族',
      'id': '0E1EBB7E2E98481BA2EAEC2ADAC7A6E8',
      'value': null
    },
    {
      'code': '54',
      'name': '仡佬族',
      'id': '206F69E5FF6E4201BC9A4E0C826F39F5',
      'value': null
    },
    {
      'code': '55',
      'name': '裕固族',
      'id': '09F4FF8F0BB042638F84C7E79F4C892B',
      'value': null
    },
    {
      'code': '56',
      'name': '壮族',
      'id': 'DE72A74C687D4BB09F1334CE5FF5F0B1',
      'value': null
    }
  ],
  'check_object': [
    {
      'code': 'common',
      'name': '通用',
      'id': 'ce080aa2-ce02-4228-913e-946071f898cf',
      'value': null
    },
    {
      'code': 'male',
      'name': '男',
      'id': 'a971fea8-5338-4794-a1a1-138a6e744155',
      'value': null
    },
    {
      'code': 'female',
      'name': '女',
      'id': 'c0843a99-be3a-42f5-9991-f5e6a0bedb13',
      'value': null
    }
  ],
  'order_type': [
    {
      'code': 'order_hospital_payment',
      'name': '待支付',
      'id': '01da27b0-16f9-49a5-92ae-219d9e217a4c',
      'value': '待支付'
    },
    {
      'code': 'order_hospital_examination',
      'name': '待体检',
      'id': '4bd645a0-8c9c-4379-9a38-ae878eb00fba',
      'value': '待体检'
    },
    {
      'code': 'order_analysis_report',
      'name': '待报告分析',
      'id': 'f41e92ca-1d8e-4e77-83f3-00208c3afa53',
      'value': '待报告分析'
    },
    {
      'code': 'order_receive_report',
      'name': '待领取报告',
      'id': '2654d24e-23dc-490e-a9c9-56e0d8faa0c1',
      'value': '待领取报告'
    },
    {
      'code': 'order_end',
      'name': '已结束',
      'id': 'bc4352ce-e924-44f7-9bea-1cfebdbc7654',
      'value': '已结束'
    },
    {
      'code': 'order_refund',
      'name': '退款中',
      'id': '14a5a87b-eadf-4181-bfc5-c88ba27fa7cd',
      'value': '退款中'
    },
    {
      'code': 'order_closed',
      'name': '已关闭',
      'id': '831e52db-66c1-4e86-9aad-1eb223d6f22b',
      'value': '已关闭'
    },
    {
      'code': 'order_cancel',
      'name': '已取消',
      'id': '84975dbc-cfab-44a9-8b7e-47ab0f1c17ab',
      'value': '已取消'
    },
    {
      'code': 'order_apply_refund',
      'name': '申请退款',
      'id': 'f340741b-fcbb-4134-afcf-c8dade3c221d',
      'value': '申请退款'
    },
    {
      'code': 'order_complete_refund',
      'name': '已退款',
      'id': '614d677f-a0f5-4ab5-83cf-6f2c158c100a',
      'value': '已退款'
    },
    {
      'code': 'order_pending',
      'name': '待审核',
      'id': '742a7e6b-e10f-4fa0-8441-e56e9bb5ab9b',
      'value': '待审核'
    },
    {
      'code': 'order_submit',
      'name': '等待提交',
      'id': '85549e9a-2152-4ff2-a6c8-a884cb37d192',
      'value': '等待提交'
    }
  ],
  'user_diploma': [
    {
      'id': 'EDDBBDADF5C64EE08B9DCC9CFA5E9DDE',
      'name': '无',
      'code': 'wu',
      'value': ''
    },
    {
      'id': '9A20280ED51B4F6FB56D995B01AF8B5A',
      'name': '小学及以下',
      'code': 'xx',
      'value': ''
    },
    {
      'id': '2AA4092D2B54468DB8CB10E0EDEED739',
      'name': '初中',
      'code': 'cz',
      'value': ''
    },
    {
      'id': '8C577EABD40F4D2CBF2232A73F21B44C',
      'name': '高中',
      'code': 'gz',
      'value': ''
    },
    {
      'id': '0F79E8CB280549A490E4E9BDDFB5DFD1',
      'name': '中专及技校',
      'code': 'zz',
      'value': ''
    },
    {
      'id': '4EDBF321447B4011B5D16440B52A4E38',
      'name': '大学本科/专科',
      'code': 'bk',
      'value': ''
    },
    {
      'id': 'F44747AE524D42EDB0001A87CF4C951E',
      'name': '研究生及以上',
      'code': 'yjs',
      'value': ''
    },
    {
      'id': '94E63B1C365C4FF6AA2BBB84C44EEC98',
      'name': '其他',
      'code': 'qt',
      'value': ''
    }
  ],
  'product_priceArea': [
    {
      'id': '0,500',
      'name': '500以下',
      'value': '0元-500元'
    },
    {
      'id': '500,1000',
      'name': '500-1000',
      'value': '500元-1000元'
    },
    {
      'id': '1000,2000',
      'name': '1000-2000',
      'value': '1000元-2000元'
    },
    {
      'id': '2000,3000',
      'name': '2000-3000',
      'value': '2000元-3000元'
    },
    {
      'id': '3000,5000',
      'name': '3000-5000',
      'value': '3000元-5000元'
    },
    {
      'id': '5000,10000',
      'name': '5000-10000',
      'value': '5000元-10000元'
    },
    {
      'id': '10000',
      'name': '10000以上',
      'value': '10000以上'
    }
  ]
}
